export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./live-casino.vue?vue&type=template&id=7bcc4335"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/live-casino/live-casino.vue?vue&type=template&id=7bcc4335
// module id = CFET
// module chunks = 0